import * as store from './data/store.js'
import * as entropy from './data/entropy.js'
import * as auth from './authenticate.js'
import * as ui from './ui.js'
import * as reports from './reports.js'
import * as fontUtilities from './utilities/fonts.js'
import * as routerUtilities from './utilities/router.js'
import * as refreshDate from './ui/refresh-date.js'
import { format } from 'date-fns'

export function initialize() {

    document.addEventListener('DOMContentLoaded', ui.displayBrand)
    fontUtilities.applyCustomFonts()

    const token = entropy.getAuthenticationToken()
    const appArea = routerUtilities.getAppArea()
    
    if (token === null && appArea !== 'login') window.location.replace(routerUtilities.setPath({ path: 'login'}))
    if (token !== null && appArea === 'login') window.location.replace('/index.html')
		
    switch(appArea) {
        case 'login':
            auth.initialize()
            break;
        case 'reports':
            _setupCommonPages()
            reports.initialize()
            break;
        case 'home':
            _setWelcomeMessage()
            _setupCommonPages()
            break;
        default:
            console.error(`That is not a valid area of the application`)
    }

}

function _setWelcomeMessage() {
    const welcomeElement = document.getElementById('js-welcome')
    const weclomeName = store.getPortal().name ?? ''
    if (welcomeElement !== null)
        welcomeElement.innerText = `Welcome to the ${weclomeName} customer report center`
}

function _setupCommonPages() {
	const reportSelections = store.getReportSelections()
	ui.showHideReports(reportSelections)

    const owner = store.getOwner()
    ui.displayOwner({ owner })

    // Current get locations on all pages
    entropy.getAllLocations()

    const logoutButton = document.querySelectorAll('.js-logout')
    logoutButton.forEach((lb) => {
        lb.addEventListener('click', auth.logout)
    })

    const mobileMenuElement = document.getElementById('js-btn--mobile-menu')
    mobileMenuElement.addEventListener('click', ui.toggleMobileMenu)

	const currentDate = store.getDataRefreshDate()
	ui.displayLastDataRefreshDate(format(currentDate, 'MM/dd/yyyy'))
	refreshDate.checkLastRefreshDate()
	refreshDate.resetRefreshDateInterval()
}